'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { CatFieldset } from '@blocks-react/components/Fieldset';
import { useCheckboxController } from '../../../../hooks/form-controllers';
import { useEffect } from 'react';
import { Conditional } from '../../../common';
import { useFormContext } from 'react-hook-form';
import styles from '../../AssociatedDealer.module.scss';
import cx from 'classnames';
export const AssociatedDealerCheckbox = ({ name, label, fieldNote, checked = false, required = false, disabled = false, showCheckbox = true, className = '' }) => {
    const { checkboxFieldset, booleanCheckboxField } = useCheckboxController({
        name
    });
    const { setValue, resetField } = useFormContext();
    useEffect(() => {
        if (checked) {
            setValue(name, checked);
        }
        return () => {
            resetField(name);
        };
    }, [checked]);
    return (_jsx(Conditional, { test: showCheckbox, children: _jsx("div", { className: className, children: _jsxs(CatFieldset, { className: "u-color--ExtraDarkGray", ...checkboxFieldset, children: [_jsx(CatCheckboxField, { ...booleanCheckboxField, required: required, disabled: disabled, children: _jsxs("div", { className: cx(styles['padding-center'], 'cat-u-theme-typography-label'), children: [label, _jsx(Conditional, { test: required, children: _jsx("span", { className: styles['required-field'], children: ' (required)' }) })] }) }), _jsx(Conditional, { test: !!fieldNote, children: _jsx("span", { slot: "field-note", className: "mt-1", children: fieldNote }) })] }) }) }));
};
